export enum Roles {
  Admin = 'Admin',
  Manager = 'Manager',
  Rider = 'Rider',
}
